<template>
    <div v-if="state">
        <pop-form class="form-box" v-if="state" width="580px">
            <template slot="title">还款</template>
            <div class="body-box">
                <el-form ref="form" :model="formData" :rules="rules" label-width="80px">
                    <el-form-item label="应还">
                        <span class="red" v-if="arrears">¥ {{arrears}}</span>
                    </el-form-item>
                    <el-col :span="12">
                        <el-form-item label="还款" prop="actualMoney">
                            <el-input v-model="formData.actualMoney" :autofocus="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="付款方式" prop="payType">
                            <el-select v-model="formData.payType" placeholder="请选择">
                                <el-option
                                        v-for="item in payType.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>
            <template slot="foot">
                <div class="foot">
                    <el-button size="medium" @click="close">取消</el-button>
                    <el-button size="medium" type="primary" @click="settleTotal">确定还款</el-button>
                </div>
            </template>
        </pop-form>

    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    import TotalDone from "@/model/Cash/TotalDone";
    import CashGive from "@/model/Cash/CashGive";
    import CashRemark from "@/model/Cash/CashRemark";
    import CashStaffSelectBox from "@/model/Cash/CashStaffSelectBox";
    export default {
        name: "StoreUserRepayment",
        components: {CashStaffSelectBox, CashRemark, CashGive, TotalDone, PopForm},
        model: {
            event: "showChange",
            prop: "state"
        },
        props: {
            state: {
                type: Boolean,
                default: false
            },
            storeUid: {
                type: String,
                default: "",
            },
            arrears: {
                type: [String, Number],
                default: ""
            }
        },
        data: () => {
            return {
                formData: {
                    actualMoney: "",
                    payType: "",
                },
                payType: {
                    value: 4,
                    options: [
                        { label: "微信", value: 2},
                        { label: "支付宝", value: 3},
                        { label: "现金", value: 4},
                        { label: "银联卡", value: 5}
                    ]
                },
                rules: {
                    actualMoney: [
                        {required: true, message: "请填写还款金额"}
                    ],
                    payType: [
                        {required: true, message: "请选择付款方式"}
                    ]
                }
            };
        },
        mounted: function () {

        },
        methods: {
            //初始数据
            initData(){
                this.formData.actualMoney = this.arrears;
            },
            //关闭
            close(){
                this.$emit("showChange", false);
            },
            //确定
            settleTotal(){
                this.$refs.form.validate(d => {
                    if(!d) return false;

                    let postData = {
                        store_uid: this.storeUid,
                        money: this.formData.actualMoney,
                        pay_type: this.formData.payType
                    };
                    this.$root.postData("store_user/repayment", postData, res => {
                        if(res.errcode === 0) {
                            this.$root.success("还款成功");
                            this.$emit("onSuccess");
                            this.close();
                        }else{
                            this.$root.error(res.errdesc);
                        }
                    });
                });
            }
        },
        watch: {
            //显示状态
            state: function (newData) {
                if(newData)
                    this.initData();
            },
            "formData.actualMoney"(val){
                if(parseFloat(val) > this.arrears) {
                    this.formData.actualMoney = this.arrears;
                }
            }
        }
    }
</script>

<style scoped>
    .form-box{

    }
    .body-box{
        display: flex;
        padding-right: 10px;
        padding-bottom: 20px;
    }
    .foot{
        text-align: right;
        padding: 0px 20px 10px;
    }
</style>
